module.exports = __webpack_public_path__ + "img/ic_left_bottom.72303a3a.png";